export default {
  // Common uses
  'buttonAdd': '追加',
  'buttonBrowse': '参照',
  'buttonCancel': 'キャンセル',
  'buttonClear': 'クリア',
  'buttonDelete': '削除',
  'buttonDeleteData': 'データを削除する',
  'buttonDeleteWatermark': '透かしを削除',
  'buttonRemoveWatermark': 'ディスプレイから透かしを削除する',
  'buttonOk': 'OK',
  'buttonSave': '保存',
  'buttonSaveChanges': '変更を保存する',
  'buttonSubmitting': '送信中...',
  'buttonSubmitData': 'データを送信する',
  'confirmRemoveFunc': 'この関数を削除してもよろしいですか?',
  'labelCompanyName': 'オクトン インターナショナル 株式会社',
  'labelDataLoading': '読み込み中...',
  'labelDbData': 'データベースデータ',
  'labelHtmlFile': 'HTML ファイル',
  'labelNoDbDataFound': 'データベースにデータが見つかりません',
  'labelRequired': '必要',
  'labelRequiredFields': '必須フィールド',
  'labelSearch': '検索',
  'labelUrl': 'URL',
  'notifAutoLoggedOut': '非アクティブのためログアウトされました。 もう一度ログインしてください',
  'notifGetTokenError': 'トークン取得エラー',
  'placeholderEnter': '入力',
  "autoCreateKey":"新しいキーを自動挿入できませんでした",
  'refresh':'Refresh',
  // Login.vue
  'buttonLogin': 'ログイン',
  'buttonCreateAccount': 'アカウントを作成する',
  'labelCopyrightMessage': 'すべての権利を保有します',
  'labelCreateNewAcccount': '新しいアカウントを作成する',
  'labelDataRetrieveFail': 'サーバーからデータを取得できませんでした',
  'labelInitializing': '初期化中...',
  'labelSignInMessage': 'アカウントにサインインする',
  'labelWelcomeMessage': 'OneConsole',
  'notifAccountAllInvalid': '入力はどの条件にも一致しません',
  'notifAccountStarnumInvalid': 'スター番号が長すぎます。10 - 12 桁以内にしてください',
  'notifLoginError': `'user_id'ユーザーログインに失敗しました。エラーメッセージ: error_message`,
  'notifLoginSuccess': `'user_id'ユーザーログインに成功しました`,
  'notifNoRolesAssigned': 'このアカウントには役割が割り当てられていません！',
  'placeholderAccount': 'アカウントを入力してください',
  'placeholderPxd': 'パスワードを入力してください',
  'placeholderSelectCompanyID': '会社IDを選択',
  'notifErrorListDb': '/listdb API の呼び出しに失敗しました',
  'notifErrorLoadLanguage': 'language.db の読み込みに失敗しました',
  'notifErrorLoadSettings': '設定の読み込みに失敗しました',
  'notifNoCidFound': '会社IDが見つかりません',
  // AppHeaderDropdownNotif.vue
  'labelNewNotification': '新着',
  'labelNewNotificationMessage': 'メッセージ',
  'labelConfirmAction': '操作の確認',
  'labelNoNotifications': '通知はありません',
  'titleAlertNotification': 'アラート通知',
  'titleInfoNotification': 'インフォ通知',
  'titleOtherNotification': 'その他の通知',
  'titleWarningNotification': '警告通知',
  // AppHeaderDropdownAcct.vue
  'confirmLogout': 'ログアウトしてもよろしいですか？',
  'labelSettings': '設定',
  'labelChangeCompanyId': '会社IDを変更',
  'labelPluginManage': 'プラグインの管理',
  'labelPluginInstall': 'プラグインをインストール',
  'labelGetAccount': 'ライセンス',
  'labelChangePxd': 'パスワードを変更',
  'labelLogout': 'ログアウト',
  // AppSidebar.vue、IStoreSidebarNav.vue
  'labelAddNode': 'ノードの追加',
  'labelAddPlugin': 'プラグインを追加',
  'labelAddRoot': 'ルートを追加',
  'labelEditNode': 'ノードの編集',
  'labelEditPlugin': 'プラグインの編集',
  'labelEditRoot': 'ルートの編集',
  'labelRemoveNode': 'ノードの削除',
  'labelRemovePlugin': 'プラグインを削除',
  'labelRemoveRoot': 'ルートを削除',
  // DefaultLayout.vue
  'notifRemoveNodeError': 'ノード削除エラー!',
  'notifRemoveNodeSuccess': 'ノードが正常に削除されました',
  'notifRemovePluginError': 'プラグイン削除エラー!',
  'notifRemovePluginSuccess': 'プラグインは正常に削除されました',
  'notifRemoveRootError': 'ルート削除エラー!',
  'notifRemoveRootSuccess': 'ルートが正常に削除されました',
  // FunctionCreator.vue, FunctionEditor.vue
  'buttonAddField': 'フィールドを追加',
  'labelAddOneField': `'what_button' をクリックして送信する前に、少なくとも 1 つ以上のフィールドを追加してください`,
  'labelDatabase': 'データベース',
  'labelDisabled': '無効',
  'labelDisplayName': '表示名',
  'labelModule': 'モジュール',
  'labelName': '名前',
  'labelOrder': '順序',
  'labelParent': 'パス',
  'labelRequiredDisplayName': '表示名を入力してください',
  'labelRequiredKey': 'データベースのキーを入力してください',
  'labelRequiredModule': 'モジュールを入力してください',
  'labelRequiredName': '名前を入力してください',
  'labelType': 'ストアのタイプ',
  'notifAddNodeSuccess': '新しいノードが正常に追加されました',
  'notifAddNodeError': '新しいノードの追加に失敗しました',
  'notifHideNodeSuccess': 'ノードを正常に非表示にしました',
  'optionCustom': 'カスタム',
  'optionJson': 'JSON',
  'optionPath': 'パス',
  'optionUrl': 'URL',
  'placeholderDisplayName': '表示名を入力してください',
  'placeholderField': 'フィールド名を入力してください',
  'placeholderKey': 'データベースのキーを入力してください',
  'placeholderModule': 'モジュールを入力してください',
  'placeholderName': '名前を入力してください',
  'placeholderNameTable': '自動入力',
  'placeholderOrder': '順序を入力してください',
  'titleAddNode': 'ノードを追加',
  'titleEditNode': 'ノードを編集',
  'titleTableFieldName': 'フィールド名',
  'titleTableFieldType': 'フィールドタイプ',
  'titleTableFormat': 'フォーマット',
  'titleTableInRow': '行内で',
  'titleTableInSearch': '検索中',
  'titleTableRequired': '必要',
  'titleTableRemove': '削除する',
  // CreateNewData.vue, DataViewer.vue, DataEditor.vue
  'confirmDataDelete': 'データを削除してもよろしいですか？',
  'labelDataFound': 'データが見つかりました',
  'labelDisplayRows': '行を表示',
  'labelEntries': 'エントリー',
  'labelNoDataFound': `item_database データベースにデータが見つかりません`,
  'labelNoDataFoundSearch': `item_database データベースに search_term 検索キーワードでデータが見つかりません`,
  'labelSelected': '選択済み',
  'labelOf': 'の',
  'labelRows': '行',
  'labelRequiredDate': '日付を設定してください',
  'labelRequiredEmail': 'メールアドレスを入力してください',
  'labelRequiredNumber': '数字を入力してください',
  'labelRequiredString': 'データを入力してください',
  'labelSearchBy': '検索',
  'labelShowing': '表示中',
  'labelTotalData': '合計データ',
  'notifAddDataError': 'データを追加する際にエラーが発生しました',
  'notifAddDataSuccess': 'データが正常に追加されました',
  'notifDataEditError': '変更の保存エラー',
  'notifDataEditSuccess': 'データが正常に編集されました',
  'notifDataDeleteError': 'データ削除時のエラー',
  'notifDataDeleteSuccess': 'データが正常に削除されました',
  'notifEditNodeError': 'ノードの編集に失敗しました',
  'notifEditNodeSuccess': 'ノードの編集が成功しました',
  'notifKeyNotFound': 'キーの値が見つかりません',
  'notifJsonEditError': 'データの解析に失敗しました、編集内容を再確認してください',
  'notifPropertiesEditError': 'プロパティ文字列の形式が正しくありません、編集内容を再確認してください',
  'placeholderAddDbKey': 'データベースのキー（自動入力）',
  'titleAddDataModal': 'データの追加',
  'titleEditDataModal': 'データの編集',
  'tooltipAddDataButton': 'データを追加',
  'tooltipDeleteDataButton': 'データを削除',
  'tooltipExportDataButton': 'データをエクスポート',
  'tooltipImportDataButton': 'データをインポート',
  'tooltipShowCheckboxButton': 'チェックボックスを表示（データを選択）',
  // ImportExportModal.vue
  'labelChooseOneOfColumns': '列を1つ選択',
  'labelExportAs': 'エクスポート形式',
  'labelSelectAll': 'すべて選択',
  'labelChooseColumnsToExport': 'エクスポートする列を選択',
  'labelChooseColumnsToImport': 'インポートする列を選択',
  'notifImportDataSuccess': 'データのインポートに成功しました',
  'notifImportDataError': 'インポート中にエラーが発生しましたデータ',
  'notifInvalidCsv': '無効なCSVファイル',
  'placeholderExportFilename': 'エクスポートファイル名',
  'titleExportDataModal': 'データのエクスポート',
  'titleImportDataModal': 'データのインポート',
  // AccountCreator.vue、AccountEditor.vue
  'buttonAddUser': 'ユーザーを追加',
  'buttonEditUser': 'ユーザーを編集',
  'buttonRemoveUser': 'ユーザーを削除',
  'labelActions': 'アクション',
  'labelActivated': 'アクティブ化済み',
  'labelActivatedDate': 'アクティブ化日',
  'labelDateEmpty': '日付を入力してください',
  'labelEmail': '電子メール',
  'labelInvalidEmailFmt': '電子メール形式が無効です。次のようなものを入力してください: test@mail.com',
  'labelLanguage': '言語',
  'labelPxd': 'パスワード',
  'labelSuspend': '一時停止',
  'labelUserId': 'ユーザーID',
  'labelUserName': 'ユーザー名',
  'labelUserStatus': 'ユーザーステータス',
  'labelRole': '役割',
  'labelCid': '会社 ID',
  'labelDepartment': "部門",
  'notifAddUserError': 'ユーザー登録時にエラーが発生しました!',
  'notifAddUserSuccess': 'ユーザーの登録に成功しました',
  'notifDifferentUidEmail': 'ユーザー ID とメールアドレスが同じではありません!',
  'notifDuplicateData': 'このユーザー ID はすでに別のユーザーによって使用されています!',
  'notifModifyUserError': 'ユーザー データの編集中にエラーが発生しました!',
  'notifModifyUserSuccess': 'ユーザーデータの編集に成功しました',
  'notifNoWhiteSpcUid': 'ユーザー ID には空白は使用できません!',
  'notifSetActivatedDate': '\'有効化日\'を設定してください。',
  'placeholderEmail': 'メールアドレスを入力してください',
  'placeholderUserId': 'ユーザーIDを入力してください',
  'placeholderUserName': 'ユーザー名を入力してください',
  'titleAddNewUser': '新しいユーザーを追加',
  'titleEditUserData': 'ユーザーデータを編集',
  'titleShowPxd': 'クリックするとパスワードが表示されます',
  'notifCopyPxd': 'パスワードがクリップボードにコピーされました！',
  'labelResetPxd': 'パスワードをリセット',
  'notifChooseCid': '会社 ID を選択してください',
  'system.accountManager.column.userName': 'ユーザー名',
  'system.accountManager.column.roleNames': 'ロール',
  // ChangePxd.vue
  'labelConfirmNewPxd': '新しいパスワードを確認',
  'labelCurrentPxd': '現在のパスワード',
  'labelNewPxd': '新しいパスワード',
  'placeholderConfirmNewPxd': '新しいパスワードを再入力',
  'placeholderCurrentPxd': '現在のパスワードを入力',
  'placeholderNewPxd': '新しいパスワードを入力してください',
  'notifChangePxdError': 'パスワードの変更に失敗しました',
  'notifChangePxdSuccess': 'パスワードが正常に変更されました',
  'notifPxdIncorrect': 'パスワードが間違っています!',
  'notifPxdInvalid': 'パスワードの形式が無効です！',
  'notifPxdNotFound': 'パスワードが見つかりません!',
  'notifPxdRecheck': '新しいパスワードを再確認してください!',
  'titleChangePxd': 'パスワードを変更',
  // PluginManager.vue
  'titlePluginManage': 'プラグインの管理',
  'buttonPluginUpdate': 'プラグインを更新',
  'buttonPluginInstall': 'プラグインをインストール',
  'buttonExcludePlugin': '除外する',
  'buttonIncludePlugin': '含む',
  'notifInstallPluginSuccess':'プラグインのインストールに成功しました!',
  'notifDataNeed2BeSelected':'少なくとも 1 つのプラグインを選択してください',
  'labelInstallPlugin':'新しいプラグインを追加',
  // GetAccount.vue
  'titleGetAcc':'ライセンス',
  'labelSerialNumber':'シリアル番号',
  'placeholderSerialNumber':'シリアル番号を入力してください',
  'labelIPAddr':'WAN IP アドレス',
  'placeholderIPAddr':'IP アドレスを入力してください',
  'labelMACAddr':'MAC アドレス',
  'placeholderMACAddr':'MAC アドレスを入力してください',
  'labelProvisioning':'プロビジョニング中...',
  // RoleCreator.vue, RoleEditor.vue
  'labelRoleName': '役割名',
  'labelRoleId': '役割ID',
  'labelLevelId': '役割レベル',
  'labelFunctionsToAssign': '割り当てる機能',
  'titleAddRoleModal': '新しい役割を定義',
  'titleEditRoleModal': '役割を編集',
  // BackupServerCreator.vue、BackupServerEditor.vue
  'labelCompanyId': '会社 ID',
  'labelCompanyIdExists': '会社 ID が存在します',
  'labelEncrypt': '暗号化',
  'labelFileUrl': 'ファイル URL',
  'labelImAddress': 'IM アドレス',
  'labelIndexServers': 'インデックス サーバー',
  'labelPushServicePort': 'プッシュ サービス ポート',
  'labelPushServicePortal': 'プッシュ サービス ポータル',
  'labelStarNumberType': 'スター番号タイプ',
  'labelStarVPort': 'StarV ポート',
  'notifAddServerBackupError': 'バックアップ サーバー構成の追加中にエラーが発生しました!',
  'notifAddServerBackupSuccess': 'バックアップ サーバー構成が正常に追加されました',
  'notifEditServerBackupError': 'バックアップ サーバー構成の編集中にエラーが発生しました!',
  'notifEditServerBackupSuccess': 'バックアップ サーバー構成の編集に成功しました',
  'notifCheckRequiredData': '必須データが空かどうか確認してください',
  'notifDuplicateCompanyId': '会社 ID が存在します!別の会社 ID を使用してください',
  'placeholderCompanyId': '会社 ID を入力してください',
  'placeholderFileUrl': 'ファイル URL を入力してください',
  'placeholderIMAddr': 'IM アドレスを入力してください',
  'placeholderINode': 'iNode 構成を入力してください',
  'placeholderIp': 'IP 構成を入力してください',
  'placeholderPushServicePort': 'プッシュ サービス ポートを入力してください',
  'placeholderPushServicePortal': 'プッシュ サービス ポータルを入力してください',
  'placeholderStarNumberType': 'スター番号タイプを入力してください',
  'placeholderStarVPort': 'StarV ポートを入力してください',
  'titleAddBackupServer': '新しいバックアップ サーバーを定義します',
  'titleEditBackupServer': 'バックアップサーバーの編集',
  // Page404.vue
  'labelPage404Message': 'お探しのページは見つかりませんでした',
  'titlePage404': '申し訳ございません',
  // WatermarkSetting.vue
  'confirmWatermarkDelete': 'このウォーターマークを削除してもよろしいですか?',
  'labelAddNewWatermark': '新しいウォーターマークを追加',
  'labelNoWatermark': 'ウォーターマークなし',
  'labelSelectWatermark': 'ウォーターマークを選択',
  'labelWatermarkFile': 'ウォーターマークファイル',
  'labelWatermarkName': 'ウォーターマーク名',
  'labelWatermarkPreview': 'プレビュー',
  'labelWatermarkSetting': 'ウォーターマーク設定',
  'notifAddWatermarkError': '新しいウォーターマークを追加できませんでしたウォーターマーク!',
  'notifAddWatermarkSuccess': '新しいウォーターマークを正常に追加しました',
  'notifDeleteWatermarkError': '\'watermark_name\' ウォーターマークの削除に失敗しました!',
  'notifDeleteWatermarkSuccess': '\'watermark_name\' ウォーターマークを正常に削除しました',
  'notifSetWatermarkError': 'ウォーターマークの設定に失敗しました!',
  'notifSetWatermarkSuccess': 'ウォーターマークを正常に設定しました',
  'placeholderWatermarkFile': 'ウォーターマーク ファイルをアップロードしてください',
  'placeholderWatermarkName': 'ウォーターマーク名を入力してください',
  'placeholderWatermarkSelect': 'ウォーターマークを選択してください',
  'titleWatermarkSetting': 'ウォーターマークの設定',
  // DepartmentManager.vue
  "titleAddDepartmentModal": "新しい部署を追加",
  "titleEditDepartmentModal": "部署を編集",
  "system.departmentManager.column.departmentName": "部署名",
  "system.departmentManager.column.departmentDescription": "部署の説明",
  "system.departmentManager.column.users": "ユーザー",
  "system.departmentManager.column.roles": "役割",
  // LanguageCreator.vue, LanguageEditor.vue
  'labelLangKey': 'KEY',
  'labelEnglish': '英語',
  'labelTaiwanese': '中国語（繁体字）',
  'labelChinese': '中国語（簡体字）',
  'labelJapanese': '日本語',
  "titleAddLanguageData": "言語データを追加",
  "titleEditLanguageData": "言語データを編集",
  // PluginInstaller.vue
  "labelPluginName":"プラグイン名",
  'notifAddBinSuccess': 'バイナリのアップロードに成功しました',
  'notifSetBinError': 'バイナリのアップロードに失敗しました!',
  // ApiManager.vue
  'system.apiManager':'API Manager'
}
